var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBitbucket = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 16,
  viewBox: "0 0 16 16",
  width: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.1453 7.25401-1.0398 6.35169c-.0679.3843-.3391.6103-.7234.6103h-8.81543c-.38424 0-.65548-.226-.7233-.6103l-1.83091-11.32454c-.06782-.38427.1356-.63291.49727-.63291h12.92947c.3617 0 .5652.24864.4974.63291l-.4974 2.98373c-.0678.42946-.3165.61031-.7234.61031h-7.7757c-.11304 0-.18082.06778-.15825.20342l.61034 3.75224c.0226.09043.09039.15825.18082.15825h2.80287c.09043 0 .15825-.06782.18086-.15825l.42945-2.71245c.04521-.33906.27121-.4747.58771-.4747h3.0515c.4521 0 .5878.22606.5199.6103z",
  fill: "currentColor"
})));
export default SvgBitbucket;